import { removeEmptyProps } from "utils";

export const isValidZip = value => {
  return /^\d{5}(-?\d{4})?$/.test(value);
};

export const mapFilter = filter => {
  const mapped = {
    text: filter.value,
    state: filter.state,
    status: filter.status,
    userId: filter.userId,
    ExternalId: filter.ExternalId
  };

  return removeEmptyProps(mapped);
};
